import { graphql } from "@/api/graphql/types/gql";

export const disableAgentMutation = graphql(`
  mutation DisableAgent($request: AccountsMsDisableSupportUserRequest) {
    AccountsMsDisableSupportUser(request: $request)
  }
`);
